// Spirit Admin official brand assets (optimized webp).
export const BRAND = {
  icon: "/brand/profile.webp",        // square meditating-figure profile icon (navbar/logo)
  logo: "/brand/profile.webp",        // alias kept for backward-compat
  vortex: "/brand/vortex.webp",       // cosmic atmosphere artwork
  hero: "/brand/hero.webp",           // cinematic hero key visual
  atmosphere: "/brand/atmosphere.webp", // cinematic backdrop for inner pages
  categories: {
    Discipline: "/brand/cat_discipline.webp",
    Identity: "/brand/cat_identity.webp",
    Healing: "/brand/cat_healing.webp",
    Purpose: "/brand/cat_purpose.webp",
    Faith: "/brand/cat_faith.webp",
    Mindfulness: "/brand/cat_mindfulness.webp",
  },
};
